<template>
  <div class="flex h-full font-sans">
    <Topbar/>

    <Sidebar/>
    <div class="flex flex-row flex-wrap flex-1 flex-grow content-start pl-16">

      <!--Aside Content -->
      <Animated
        enter="slideInLeft"
        leave="slideOutLeft"
      >
        <div
          v-if="hasAside && canViewAside"
          id="dash-content"
          class="bg-gray-200 h-full overflow-auto p-6 lg:p-4 lg:pt-24 w-full lg:max-w-sm flex flex-wrap flex-col"
        >
          <Aside
            :aside="aside"
          />
        </div>
      </Animated>

      <!--Main Content -->
      <div id="main-content" class="lg:pt-16 pt-40 w-full flex-1">
        <child/>

        <ChatBox/>
      </div>
    </div>
  </div>
</template>

<script>
import {includes} from 'lodash';
import {mapGetters, mapState} from 'vuex';
import Topbar from '@/components/Topbar.vue';
import Aside from '@/components/sidebar/Aside.vue';
import Sidebar from '@/components/sidebar/Sidebar.vue';
import ChatBox from '@/components/widgets/ChatBox.vue';

export default {
  components: {
    Sidebar,
    Topbar,
    Aside,
    ChatBox,
  },

  computed: {
    ...mapState('civium', [
      'aside'
    ]),

    ...mapGetters('civium', [
      'hasAside'
    ]),

    ...mapGetters('auth', [
      'modeActions'
    ]),

    /**
     * Will tell us if user can view this specific aside on this mode.
     *
     * @return {Boolean}
     */
    canViewAside() {
      return includes(this.modeActions, this.aside.key);
    }
  }
}
</script>

<style lang="scss">
.nunito {
  font-family: 'nunito', font-sans;
}

.border-b-1 {
  border-bottom-width: 1px;
}

.border-l-1 {
  border-left-width: 1px;
}

hover\:border-none:hover {
  border-style: none;
}
</style>
